import React from 'react';
import logo from '../../assets/images/logo-sm-dark.png';

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="account-pages auth-pages-v2">
      <div className="auth-shell">
        <div className="auth-panel">
          <div className="auth-panel-inner">
            <a href="/" className="auth-logo-mark">
              <img src={logo} alt="" />
            </a>
            <h5 className="auth-title">{title}</h5>
            {subtitle && <p className="auth-subtitle">{subtitle}</p>}
            {children}
          </div>
        </div>
        <div className="auth-showcase">
          <img src="/assets/images/layouts/auth-showcase.png" alt="" />
        </div>
      </div>
    </div>
  );
}
